import AdmLogin from '@/components/EnbAdm/AdmLogin'
import WorkSpace from '@/components/EnbAdm/WorkSpace'
import EnbSignatures from '@/components/EnbAdm/signatures/EnbSignatures'
import EnbContas from '@/components/EnbAdm/contas/EnbContas'
import EnbBlacklist from '@/components/EnbAdm/blacklist/EnbBlacklist'
import AddBlacklist from '@/components/EnbAdm/blacklist/AddBlacklist'

export default [
  {
    path: '/enb/login',
    name: 'AdmLogin',
    component: AdmLogin
  },
  {
    path: '/enb/workspace',
    name: 'WorkSpace',
    component: WorkSpace,
    children: [
      {
        path: '/enb/workspace/signatures',
        Name: 'Assinaturas',
        component: EnbSignatures
      },
      {
        path: '/enb/workspace/contas',
        Name: 'Contas',
        component: EnbContas
      },
      {
        path: '/enb/workspace/blacklist',
        Name: 'Blacklist',
        component: EnbBlacklist
      },
      {
        path: '/enb/workspace/addblacklist',
        Name: 'Adicionar Blacklist',
        component: AddBlacklist
      }
    ]
  }
]
